<template>
  <div ref="self">
    <div ref="mainHeader" class="mainHeader">
      <slot name="mainHeader"></slot>
    </div>
    <div class="page" :style="getPageStyle">
      <slot name="page" :layoutParams="params"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      headerHeight: 50,
      params: {
        windowHeight: 0,
        mainHeaderHeight: 0,
        pageHeight: 0,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getWindowSize();
    });
    window.addEventListener("resize", this.getWindowSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowSize);
  },
  computed: {
    getPageStyle() {
      //全体の高さから、ヘッダーの高さを引く
      let style = `height:${this.params.pageHeight}px;`;
      return style;
    },
  },
  methods: {
    getWindowSize() {
      const self = this.$refs.self;
      const mainHeader = this.$refs.mainHeader;
      if (self && mainHeader) {
        //全体のサイズを取得
        const mainHeaderRect = mainHeader.getBoundingClientRect();
        //params全体を更新
        let _params = { ...this.params };
        //ヘッッダーの高さを引いてMainを算出
        _params.pageHeight = window.innerHeight - this.headerHeight;
        _params.mainHeaderHeight = mainHeaderRect.height;
        _params.windowHeight = window.innerHeight;
        this.params = _params;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mainHeader {
  position: fixed;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  z-index: 99;
}
.page {
  margin-top: 50px;
}
</style>
